import React from 'react';

export function TTLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="31"
      viewBox="0 0 30 31"
      className="fill-black dark:fill-white"
    >
      <path d="M30 0H0V8.14485H12.1682C7.08499 9.4008 3.32007 13.9611 3.32007 19.3999C3.32007 24.8388 8.54973 31 15 31C21.4503 31 26.6799 25.8091 26.6799 19.3999C26.6799 12.9908 22.915 9.4008 17.8318 8.14485H30V0Z" />
    </svg>
  );
}
